import React, { useRef, useState, useEffect, useMemo } from "react"
//import { Link } from 'react-router-dom';
import WPApiFetch from '../Utility/WPApi'
import { debounce } from '../Utility/debounce'
import { decode } from 'html-entities';
import { useLocation } from 'react-router-dom'
//import { unSlash } from '../Utility/unSlash'
//const htmlEntities = new Html5Entities();

const SearchResultsItem = ({item}) => (
	<li className="product" key={item.id}>
		<a href={item.url}>

		{/*<Link to={{pathname: unSlash( item.url.replace(replaceUrls.search, replaceUrls.replace) ) }}>*/}
			<img alt={item.title} src={item.image} />
		{/*</Link>*/}
		</a>
		<div>
			<a href={item.url}>
			{/*<Link to={{pathname: unSlash( item.url.replace(replaceUrls.search, replaceUrls.replace) ) }}>*/}
				<h4>{decode(item.title)}</h4>
				<p>{decode(item.excerpt)}</p>
			{/*</Link>*/}
			</a>
		</div>
	</li>
)
const SearchResults = ({entries,total,search}) => {
	return (<div id="header-search-dropdown-products">
		<ul>
			{parseInt( total ) > 0 ? <li><h4>Products ({total})</h4></li> : <li className="header-search-no-results">{"We are sorry, there are no results for \""+search+".\" Please try something else."}</li>}
			{entries.map((item, inx) => <SearchResultsItem key={item.id} item={item} />)}
			<li className="header-search-links">
				{parseInt( total ) > 0 && <div><a className="header-search-all-link" href={"/?s="+search+"&post_type=product"}>See All Results</a></div>}
				<div><a className="header-search-advanced-link" href={"/advanced-search/"}>Advanced Search</a></div>
			</li>
		</ul>
	</div>
	)
}
const Search = () => {
	const location = useLocation();
    const searchWrapper = useRef(null);
	const [data, setData] = useState(null);
	const [search, setSearch] = useState(null);

	const fetchData = useMemo(() => debounce(async (value) => {
  		const data = await WPApiFetch('/wp/v2/search?search='+value+'&per_page=3&subtype=product&orderby=relevance', null, 'GET', null, 'omit')
  		setData(data);
	}, 400), []);

	useEffect(() => {
		setData(null);
		if (search && search !== "") {
			fetchData(search);
		}
	   // eslint-disable-next-line react-hooks/exhaustive-deps
	}, [search]);
	
	useEffect(() => {
		setSearch(null)
	}, [location])

    useEffect(() => {
        function handleClickOutside(event) {
            if (searchWrapper.current && !searchWrapper.current.contains(event.target)) {
				setSearch(null)
            }
        }
        document.addEventListener("mousedown", handleClickOutside);
        return () => {
            document.removeEventListener("mousedown", handleClickOutside);
        };
    }, [searchWrapper]);


	return (
		<div ref={searchWrapper} className="header-search-wrapper">
			<form method="get" action="/">
				<label htmlFor="header-search"><i className="fa fa-search" aria-hidden="true"></i><span className="">Search</span></label>
				<input type="hidden" name="post_type" value="product" />
				<input type="text" id="header-search" className="header-search" name="s" placeholder="Search Sample Packs & Software" autoComplete="off" onChange={ev => setSearch(ev.target.value) } />
				<input className="header-search-submit" type="submit" value="Search"/>
				{/*<a id="header-search-clear"><i className="fa fa-close"></i></a>*/}
			</form>
			<a className="advanced-search-link" href={"/advanced-search/"}>Advanced Search</a>
			<div className={"header-search-dropdown "+( !data ? " loading " : '' )+( search && " visible " )} id="header-search-dropdown">
				{data ? <SearchResults entries={data} total={data.total} search={search} /> : <div className="loading-spinner"></div>}
				<div id="header-search-dropdown-other"></div>
			</div>
		</div>
	)
}
export default Search